/**
 * 订单管理 订单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>激活码管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="关键词:">
        <el-input
          size="small"
          v-model="formInline.word"
          placeholder="请输入关键词"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="addCode"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="actCode"
        label="激活码"
        width="170"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="channelName"
        label="渠道名"
        width="130"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="pid"
        label="云手机ID"
        width="230"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="codeNum"
        label="时间数量"
        width="110"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="type"
        label="时间类型"
        width="130"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column align="center" prop="useDays" label="使用时间" width="110" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="vipName"
        label="VIP类型"
        width="110"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="useTime"
        label="兑换时间"
        width="170"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="status"
        label="状态"
        width="90"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column align="center" label="操作" fixed="right"  min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="addCode(scope.$index, scope.row)">添加及说明</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="addFormVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @click="closeDialog('edit')"
    >
      <el-form
        label-width="100px"
        :model="addForm"
        :rules="rules"
        ref="addForm"
      >
        <el-form-item label="VIP类型" prop="vid">
          <el-select
            size="small"
            v-model="addForm.vid"
            placeholder="请选择会员类型"
            class="userRole"
          >
            <el-option
              v-for="item in vipType"
              :key="item.value"
              :label="item.key"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间类型" prop="type">
          <el-select
            size="small"
            v-model="addForm.type"
            placeholder="请选择会员类型"
            @change="changeTime"
            class="userRole"
          >
            <el-option
              v-for="item in dayType"
              :key="item.value"
              :label="item.key"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="codeNum" label="时间数量">
          <el-input
            size="small"
            v-model="addForm.codeNum"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="时常" v-if="addForm.codeNum && addForm.type">
          <div>{{ addForm.codeNum + timeData }}</div>
        </el-form-item>

        <el-form-item prop="channelCode" label="渠道编码">
          <el-input
            size="small"
            v-model="addForm.channelCode"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="channelName" label="渠道名称">
          <el-input
            size="small"
            v-model="addForm.channelName"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">关闭</el-button>
        <el-button size="mini" type="danger" @click="addCodeData('addForm')"
          >添加</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { actCodePage, actCodeCreate } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      loading: false, //是显示加载
      listDataArr: [],
      addFormVisible: false, //控制编辑页面显示与隐藏
      timeData: "",
      money: 0,
      title: "预览",
      vipType: [
        { key: "VIP", value: 3 },
        { key: "KVIP", value: 4 },
        { key: "SVIP", value: 5 },
        { key: "DVIP", value: 7 },
        { key: "GVIP", value: 6 },
        { key: "MVIP", value: 8 },
      ],
      dayType: [
        { key: "小时", value: "hour" },
        { key: "天", value: "day" },
        { key: "周", value: "week" },
        { key: "月", value: "month" },
        { key: "季", value: "season" },
        { key: "年", value: "year" },
      ],
      addForm: {
        vid: "",
        type: "",
        codeNum: null,
        channelCode: "",
        channelName: "",
      },
      formInline: {
        pageNo: 0,
        pageSize: 10,
        word: "",
        // token: localStorage.getItem('logintoken')
      },

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      rules: {
        vid: [{ required: true, message: "请选择会员类型", trigger: "blur" }],
        type: [{ required: true, message: "请选择时间类型", trigger: "blur" }],
        codeNum: [
          { required: true, message: "请输入添加时间数量", trigger: "blur" },
        ],
        channelCode: [
          { required: true, message: "请输入渠道编码", trigger: "blur" },
        ],
        channelName: [
          { required: true, message: "请输入渠道名称", trigger: "blur" },
        ],
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    this.getdata(this.formInline);
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    changeTime() {
      console.log(123);
      this.dayType.forEach((item) => {
        if (item.value == this.addForm.type) {
          if (item.key == "月") {
            this.timeData = "个月";
          } else {
            this.timeData = item.key;
          }
        }
      });
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true;
      // 模拟数据开始
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      console.log("diaoyon ");
      actCodePage(parameter)
        .then((res) => {
          this.loading = false;
          if (res.success == false) {
            this.$message({
              type: "info",
              message: res.msg,
            });
          } else {
            this.listData = res.data.dataList.map((item) => {
              if (item.status) {
                item.status = "已使用";
              } else {
                item.status = "未使用";
              }
              return item;
            });
            // 分页赋值
            this.pageparm.currentPage = this.formInline.pageNo + 1;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNo = parm.currentPage - 1;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.pageNo = 0;
      this.getdata(this.formInline);
    },
    //显示编辑界面
    addCode: function (index, row) {
      this.addFormVisible = true;
      //   this.addForm = row
      //   this.money = this.addForm.goodsMoney * 1
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          ConfigSave(this.addForm)
            .then((res) => {
              this.addFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.addFormVisible = false;
              this.loading = false;
              this.$message.error("保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 退款
    addCodeData(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          actCodeCreate(this.addForm).then((res) => {
            if (res.success) {
              this.getdata(this.formInline);
              this.$message({
                type: "success",
                message: "添加成功！",
              });
              this.addForm = {
                vid: "",
                type: "",
                codeNum: null,
                channelCode: "",
                channelName: "",
              };
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }

            this.addFormVisible = false;
            // console.log('添加成功')
          });
        } else {
          return false;
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.addFormVisible = false;
      this.addForm = {
        vid: "",
        type: "",
        codeNum: null,
        channelCode: "",
        channelName: "",
      };
      //   this.$refs[formName].resetFields()
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/actcode/codepage.vue